import React from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const CreateChannelModalContainer = React.lazy(() => import("@mediaspace/features/create-channel-modal-container"));

// ds component inside no-ds page
export const render = getStandaloneComponentRenderer(CreateChannelModalContainer, true);
